<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div>
        <div class="second img-left">
          <img :src="imageSrc(item.num)" alt="">
          <div class="desc-div">
            <p class="desc">{{item.desc}}</p>
            <ul>
              <li>
                <div><p>활동 시기 :&nbsp;</p></div>
                <div><p>{{item.date}}</p></div>
              </li>
              <li>
                <div><p>활동 장소 :&nbsp;</p></div>
                <div><p>{{item.place}}</p></div>
              </li>
              <li>
                <div><p>활동 대상 :&nbsp;</p></div>
                <div><p>{{item.target}}</p></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsrFootballClinic',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 8,
          title: '축구 클리닉',
          desc: '전남드래곤즈는 지역의 어린 축구 꿈나무들에게 축구 지도와 노하우 전수하는 시간을 가지며, 어린 선수들을 동기부여하고 프로축구 선수의 꿈을 꾸고 이어나갈 수 있도록 축구 클리닉을 진행하고 있습니다.',
          date: '3 ~ 12월',
          place: '해당 학교 운동장 또는 광양축구전용구장 \n및 연습구장',
          target: '전라남도 지역 학교 축구부, 리틀드래곤즈 \n등 지역 단체'
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/program_0${num}.png`);
    },
  },
};
</script>

<style scoped>
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
}

@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
